import React, { useState } from "react"
import { Container, Row, Col, CardBody, Card, Button, CardTitle  } from "reactstrap"
import axios from "axios"

const TrackComplaint = () => {
    const [trackingNo, setTrackingNo] = useState('')
    
    const SendSMS = () => {

    }

  return (
    <React.Fragment>
            <Card>
                <CardBody>
                    <Row>
                        <Col md={12}>
                            <div className="mb-3">
                                <label htmlFor="floatingIdInput">Complaints tracking number</label>
                                <input type="text" className="form-control" value={trackingNo} onChange={(e)=>setTrackingNo(e.target.value)} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div className="d-grid gap-2">
                                <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={()=>{ SendSMS(); }}>
                                    Check Status
                                </Button>
                            </div>
                        </Col>
            
                    </Row>
                    </CardBody>
                </Card>
    </React.Fragment>
  )
}

export default TrackComplaint